import * as z from "zod";
import { gql } from "graphql-request";
import { SysSchema, SysFragment } from "./sys";
import { ButtonTargetSchema } from "./buttonTarget";

export const UnifiedButtonSchema = z.object({
  sys: SysSchema,
  __typename: z.literal("UnifiedButton"),
  buttonText: z.string().nullable(),
  buttonColorVariant: z.string().nullable(),
  buttonTarget: ButtonTargetSchema,
});

export const UnifiedButton = UnifiedButtonSchema;
export type UnifiedButton = z.infer<typeof UnifiedButtonSchema>;

export const UnifiedButtonFragment = gql`
  fragment UnifiedButtonFragment on UnifiedButton {
    sys {
      ...SysFragment
    }
    __typename
    buttonText
    buttonColorVariant
    buttonTarget
  }

  ${SysFragment}
`;
